import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * A screen's Back: to the screen before it when InGo opened this one, else to
 * `fallback` (Rio, 11 Oct 2026: "we need all navigation pages to be to go back
 * and forth pages like the policies etc").
 *
 * React Router numbers its own entries in `history.state.idx`, and 0 is the
 * page InGo was opened on: a link from outside, a reload, a notification. Back
 * from there would leave InGo, or do nothing in the app, so it goes to
 * `fallback`. `history.length` cannot tell the two apart: a browser tab counts
 * the sites visited before InGo too.
 */
export function useGoBack(fallback = '/') {
  const navigate = useNavigate();

  return useCallback(() => {
    const idx = window.history.state?.idx;

    if (typeof idx === 'number' && idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
